<template>
  <el-dialog :visible="visible"
    :append-to-body="true"
    :showClose="true"
    :title="title"
    @close="close">
    <div class="dialog-input-wrapper">
      {{text}}
    </div>
    <div class="dialog-footer-wrapper">
      <el-button @click="submit">{{submitText}}</el-button>
      <el-button @click="close">Cancel</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SubmitDialog',
  props: {
    text: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: 'Warning'
    },
    submitText: {
      type: String,
      default: 'Submit'
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    submit() {
      this.$emit('submit', this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-input-wrapper {
  padding: 16px;
}
.dialog-footer-wrapper {
  padding: 0 16px 16px 16px;
}
</style>
